import React, { useState, useEffect } from 'react';
import { Layout, Tabs } from 'antd';
import withRoleAccess from '../../hoc/withRoleAccess';
import { useTranslation } from 'react-i18next';
import Sidebar from '../../components/Sidebar/Sidebar';
import Header from '../../components/Header/Header';
import EditDeleteTeacherBase from './EditDeleteTeacher';
import EditDeleteStudentBase from './EditDeleteStudent';
import EditDeleteSubjectBase from './EditDeleteSubject';
import FilterTaskTableBase from '../Class/FilterTaskTable';
import ClassChangeBase from '../Class/ClassChange';
import ClassesBase from '../Class/Classes';
import EditDeleteClassroomBase from './EditDeleteClassroom';
import AnnouncementAdminBase from '../Announcement/AnnouncementAdmin';
import MatchTeacherSubjectBase from '../SubjectMatch/MatchTeacherSubject';
import CreateTeacherFormBase from '../CreateUserform/CreateTeacherForm';
import CreateStudentFormBase from '../CreateUserform/CreateStudentForm';
import TutorClassLogBase from '../Teacher/TutorClassLog';
import CreateCourseBase from '../Class/CreateCourse';

const EditDeleteTeacher = EditDeleteTeacherBase as any;
const EditDeleteStudent = EditDeleteStudentBase as any;
const EditDeleteSubject = EditDeleteSubjectBase as any;
const FilterTaskTable = FilterTaskTableBase as any;
const ClassChange = ClassChangeBase as any;
const Classes = ClassesBase as any;
const EditDeleteClassroom = EditDeleteClassroomBase as any;
const AnnouncementAdmin = AnnouncementAdminBase as any;
const MatchTeacherSubject = MatchTeacherSubjectBase as any;
const CreateTeacherForm = CreateTeacherFormBase as any;
const CreateStudentForm = CreateStudentFormBase as any;
const TutorClassLog = TutorClassLogBase as any;
const CreateCourse = CreateCourseBase as any;

const { Content } = Layout;

function AdminPanel() {
  const { t } = useTranslation();
  const [activeTab, setActiveTab] = useState('teachers');
  const [showCreateTeacherForm, setShowCreateTeacherForm] = useState(false);
  const [showCreateStudentForm, setShowCreateStudentForm] = useState(false);
  const [tabChangeKey, setTabChangeKey] = useState(null); // Used to signal data refetch

  const toggleCreateTeacherForm = () => {
    setShowCreateTeacherForm(!showCreateTeacherForm);
  };

  const toggleCreateStudentForm = () => {
    setShowCreateStudentForm(!showCreateStudentForm);
  };

  useEffect(() => {
    // Update tabChangeKey whenever the tab changes to trigger a data fetch in the selected component
    setTabChangeKey(activeTab);
  }, [activeTab]);

  return (
    <Layout>
      <Sidebar />
      <Layout>
        <Header />
        <Content style={{ marginTop: '60px', marginLeft: '70px', padding: '24px' }}>
        <Tabs 
  activeKey={activeTab} 
  onChange={setActiveTab} 
  className="tabs-container"
  items={[
    {
      key: "teachers",
      label: t("tutors"),
      children: showCreateTeacherForm ? (
        <CreateTeacherForm onClose={toggleCreateTeacherForm} />
      ) : (
        <EditDeleteTeacher onCreateNewTeacher={toggleCreateTeacherForm} shouldFetch={tabChangeKey === "teachers"} />
      )
    },
    {
      key: "students",
      label: t("students"),
      children: showCreateStudentForm ? (
        <CreateStudentForm onClose={toggleCreateStudentForm} />
      ) : (
        <EditDeleteStudent onCreateNewStudent={toggleCreateStudentForm} shouldFetch={tabChangeKey === "students"} />
      )
    },
    {
      key: "subjects",
      label: t("subjects"),
      children: <EditDeleteSubject shouldFetch={tabChangeKey === "subjects"} />
    },
    {
      key: "classrooms",
      label: t("classrooms"),
      children: <EditDeleteClassroom shouldFetch={tabChangeKey === "classrooms"} />
    },
    {
      key: "class",
      label: t("createCourse1"),
      children: <Classes shouldFetch={tabChangeKey === "class"} />
    },
    {
      key: "createcourse",
      label: t("createCourse2"),
      children: <CreateCourse shouldFetch={tabChangeKey === "createcourse"} />
    },
    {
      key: "courses",
      label: t("manageCourses"),
      children: <FilterTaskTable shouldFetch={tabChangeKey === "courses"} />
    },
    {
      key: "classchange",
      label: t("classchange"),
      children: <ClassChange shouldFetch={tabChangeKey === "classchange"} />
    },
    {
      key: "announcements",
      label: t("announcements"),
      children: <AnnouncementAdmin shouldFetch={tabChangeKey === "announcements"} />
    },
    {
      key: "matchteachersubject",
      label: t("matchteachersubject"),
      children: <MatchTeacherSubject shouldFetch={tabChangeKey === "matchteachersubject"} />
    },
    {
      key: "teacherhourlog",
      label: t("teacherhourlog"),
      children: <TutorClassLog shouldFetch={tabChangeKey === "teacherhourlog"} />
    }
  ]}
/>

        </Content>
      </Layout>
    </Layout>
  );
}

export default withRoleAccess(AdminPanel, ['admin', 'superadmin']);
